// extracted by mini-css-extract-plugin
export var container = "_3k-0";
export var error = "_3k-9";
export var label = "_3k-5";
export var light = "_3k-6";
export var md = "_3k-3";
export var sm = "_3k-2";
export var thin = "_3k-8";
export var thinBold = "_3k-7";
export var vertical = "_3k-4";
export var xs = "_3k-1";